import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { MemoryRouter, Route, Routes, Link, matchPath, useLocation, StaticRouter } from 'react-router';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Tabs": Tabs, "@mui/material/Tab": Tab, "@mui/material/Typography": Typography, "react-router": { MemoryRouter, Route, Routes, Link, matchPath, useLocation, StaticRouter } } } });
export default ClientProvider;
